// ============================================================
// FICHIER : boutique/config.js
// RÔLE : Paramètres du widget Toilesia (à adapter à la boutique).
// ⚠️ Chargé EN PREMIER : les autres modules s'appuient sur
//    Toilesia.config (chargé avant auth-client.js notamment).
// ============================================================

window.Toilesia = window.Toilesia || {};

Toilesia.config = {

    // --------------------------------------------------------
    // API
    // --------------------------------------------------------
    // URL publique du backend, SANS préfixe /api/ (routage front controller).
    apiUrl: 'https://api.auclairdestoiles.fr',

    // Style de la page (une page = un style). Peut aussi être défini
    // via l'attribut data-style="..." sur le conteneur du widget,
    // ou via ToilesiaWidget.init({ style: '...' }).
    style: '',

    // true  = afficher la grille complète des styles dans l'étape 2
    // false = n'afficher que le style de la page (recommandé)
    afficherTousLesStyles: false,

    // --------------------------------------------------------
    // GÉNÉRATION IA — étapes affichées pendant l'attente (~20-30 s)
    //   texte : libellé animé affiché à l'utilisateur
    //   duree : durée (ms) avant l'apparition de l'étape suivante
    // --------------------------------------------------------
    etapesGeneration: [
        { texte: 'Analyse du visage',       duree: 4000 },
        { texte: "Capture de l'expression", duree: 3500 },
        { texte: 'Détection des contours',  duree: 3500 },
        { texte: 'Étude des couleurs',      duree: 3000 },
        { texte: 'Application du style',    duree: 4000 },
        { texte: "Peaufinage de l'œuvre",   duree: 3500 }
    ],

    // Format envoyé à la génération (doit exister dans la table `formats`).
    formatGeneration: 'format_40x50',

    // --------------------------------------------------------
    // STYLES (repli si la route GET /styles est indisponible)
    // --------------------------------------------------------
    styles: [
        { code: 'aquarelle',  nom: 'Aquarelle Douce',     description: 'Une peinture douce et lumineuse' },
        { code: 'popart',     nom: 'Pop Art',             description: "Un portrait éclatant à la Warhol" },
        { code: 'astronaute', nom: 'Animal Astronaute',   description: 'Votre compagnon en mission spatiale' },
        { code: 'van_gogh',   nom: 'Nuit Étoilée',        description: 'Dans le style tourbillonnant de Van Gogh' },
        { code: 'royal',      nom: 'Portrait Royal',      description: 'Un portrait classique à la Rembrandt' }
    ],
    // Style spécial « peinture par numéro » (route dédiée) — proposé
    // séparément des styles IA dans l'étape 2.
    styleNumberPaint: { code: 'number_paint', nom: 'Peinture par Numéro' },

    // --------------------------------------------------------
    // PRODUITS COMMANDABLES
    // ⚠️ Plus AUCUNE taille / châssis / prix codé en dur ici :
    // les formats et variantes (taille, châssis) viennent du
    // catalogue Shopify (sélecteur natif de variante du thème,
    // ou chargement dynamique de /products.js côté widget).
    // --------------------------------------------------------

    // --------------------------------------------------------
    // EN CAS D'INDISPONIBILITÉ DU WIDGET (mode « page produit »)
    //   Si le widget ne peut pas s'initialiser (module non chargé,
    //   session impossible / API injoignable — ex. certificat TLS
    //   refusé par un navigateur mobile, « Failed to fetch »), le
    //   client se retrouverait devant un bouton « Ajouter au panier »
    //   SANS personnalisation possible.
    //     true  = message d'erreur affiché À LA PLACE du bouton ET
    //             ajout au panier bloqué (masquage + garde sur la
    //             soumission du formulaire) ← recommandé
    //     false = message d'information seulement (la boutique reste
    //             vendable sans personnalisation)
    bloquerCommandeSiWidgetIndisponible: true,

    // Clé localStorage de la session (identique à la page de test).
    cleSession: 'toilesia_session',

    // URL de la feuille de style du widget (résolue automatiquement si
    // le fichier est dans le même dossier que toilesia-widget.js).
    cssUrl: ''
};
